import React, {useEffect, useState} from "react"
import {Avatar, Button, Descriptions, message, Modal, Space, Spin, Tag} from "antd"
import {useDispatch, useSelector} from "react-redux"
import global from "../../global"

interface ServiceOrdersInfoProps {
  orderNo: string
  onClose: () => void
  onRefundSuccess: () => void
}

/**
 * 定义ServiceOrderInfoType
 * @constructor
 */
interface ServiceOrderInfoType {
  orderNo: string
  orderType: string
  price: number
  description: string
  serviceName: string
  created: string
  name: string
  idCard: string
  mobile: string
  programme: string
  mark:string
  address:string
  amount: number
  payStatus: string
  orderStatus: string
  remark: string
}

const ServiceOrdersInfo: React.FC<ServiceOrdersInfoProps> = ({orderNo, onClose, onRefundSuccess}) => {
  const [loading, setLoading] = useState(false)
  const [refundLoading, setRefundLoading] = useState(false)
  
  const serviceOrders = useSelector((state: any) => state.serviceOrders)
  const dispatch = useDispatch()

  const [messageApi, contextMessageHolder] = message.useMessage()

  useEffect(() => {
    if (orderNo) {
      setLoading(true)
      dispatch.serviceOrders.getInfo(orderNo).then((res: any) => {
        setLoading(false)
        if (res.code !== 0) {
          messageApi.error(res.msg || "获取订单详情失败")
        }
      }).catch(() => {
        setLoading(false)
        messageApi.error("获取订单详情失败")
      })
    }
  }, [orderNo, dispatch.serviceOrders, messageApi])

  const handleRefund = () => {
    Modal.confirm({
      title: "确认退款",
      content: `确定要对订单 ${orderNo} 进行退款操作吗？`,
      okText: "确认",
      cancelText: "取消",
      onOk: async () => {
        setRefundLoading(true)
        try {
          const res = await dispatch.serviceOrders.refund(orderNo)
          if (res.code === 0) {
            messageApi.success("退款成功")
            onRefundSuccess()
            onClose()
          } else {
            messageApi.error(res.msg || "退款失败")
          }
        } catch (error) {
          messageApi.error("退款失败")
        } finally {
          setRefundLoading(false)
        }
      }
    })
  }

  const info = serviceOrders.info as ServiceOrderInfoType

  return (
    <>
      {contextMessageHolder}
      <div>
        <Spin spinning={loading}>
          <Descriptions 
            title="" 
            column={1} 
          >
            <Descriptions.Item label="订单号">{info?.orderNo}</Descriptions.Item>
            <Descriptions.Item label="服务类型">{info?.serviceName}</Descriptions.Item>
            <Descriptions.Item label="选手姓名">{info?.name}</Descriptions.Item>
            <Descriptions.Item label="选手身份证号">{info?.idCard}</Descriptions.Item>
            <Descriptions.Item label="手机号码">{info?.mobile}</Descriptions.Item>
            <Descriptions.Item label="节目名称">{info?.programme}</Descriptions.Item>
            <Descriptions.Item label="参演编号">{info?.mark}</Descriptions.Item>
            <Descriptions.Item label="邮寄地址">{info?.address}</Descriptions.Item>
            <Descriptions.Item label="订单描述">{info?.description}</Descriptions.Item>
            <Descriptions.Item label="下单时间">{info?.created}</Descriptions.Item>
            <Descriptions.Item label="订单价格">¥{info?.price/100}</Descriptions.Item>
            <Descriptions.Item label="付款金额">¥{info?.amount/100}</Descriptions.Item>
            <Descriptions.Item label="支付状态">
              <Tag color={global.getPayStatusColor(info?.payStatus || "")}>
                {global.getPayStatusText(info?.payStatus || "")}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="订单状态">
              <Tag color={global.getOrderStatusColor(info?.orderStatus || "")}>
                {global.getOrderStatusText(info?.orderStatus || "")}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="备注">{info?.remark || "-"}</Descriptions.Item>
          </Descriptions>
        </Spin>

        <div style={{marginTop: "20px", textAlign: "center"}}>
          <Button 
            type="primary" 
            danger 
            onClick={handleRefund}
            loading={refundLoading}
            disabled={info?.payStatus !== "PAID"}
          >
            退款
          </Button>
        </div>
      </div>
    </>
  )
}

export default ServiceOrdersInfo